<template>
  <button :class="`item ${chatType}`" @click="goToCreateChat(chatType)">
    <div class="txt-wrap">
      <strong>{{ t(`label_${chatType}`) }}</strong>
      <p>{{ t(`${chatType}_description`) }}</p>
    </div>
    <div class="visual-img">
      <img :src="getAssetImageUrl(`app/deco/3d-${chatType}.png`)" alt="" />
    </div>
  </button>
</template>

<script setup lang="ts">
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

defineProps<{
  chatType: string;
}>();

const { t } = useI18n();
const router = useRouter();

const goToCreateChat = (type) => {
  router.push(`/app/chat/new/${type}`);
};
</script>

<style scoped lang="scss">
.item {
  display: block;
  padding: 1.5rem;
  border-radius: $size-m;
  color: #fff;
  text-decoration: none;
  margin-bottom: $size-m;
  width: 100%;
  &:last-child {
    margin-bottom: 0;
  }
  .txt-wrap {
    text-align: left;
    strong {
      font-size: $size-xl;
      font-weight: $font-weight-semibold;
    }
    p {
      margin-top: 0.5rem;
      color: #fff;
      font-weight: 400;
      font-size: $font-size-psmall;
      white-space: wrap;
      word-break: keep-all;
      overflow-wrap: break-word;
    }
  }
  &.meeting {
    background: $meeting;
  }
  &.conference {
    background: $conference;
  }
  &.audience {
    background: $audience;
  }
  &.general {
    background: $general;
  }
  &.single {
    background: $single;
  }
  .visual-img {
    margin-top: 1.5rem;
    text-align: right;
    img {
      height: 124px;
      object-fit: contain;
    }
  }
}

.meeting {
  .visual-img {
    img {
      transform: translateX(-0.25rem);
    }
  }
}
.conference {
  .visual-img {
    img {
      transform: translateX(0.875rem);
    }
  }
}
.audience {
  .visual-img {
    img {
      transform: translateY(0.5rem);
    }
  }
}
.general {
  .visual-img {
    img {
      transform: translateY(0.75rem);
    }
  }
}
.single {
  .visual-img {
    img {
      transform: translateX(0.375rem);
    }
  }
}
</style>
